import { defineComponent, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import './style.sass'
import axios from '@/axios'
import { host } from '@/const'
import Preloader from '@/components/preloader/preloader.vue'

export default defineComponent({
  props: {
    apiEndpoint: {
      type: String,
      default: () => '',
      required: true
    },
    reqParams: {
      type: Object,
      default: () => {},
      required: true
    },
    onShowMoreItem: {
      type: Function,
      default: (item: Record<string, unknown>) => { return item }
    },
    total: {
      type: Number,
      default: () => 1
    }
  },
  setup (props: any) {
    const end = ref(false)
    const route = useRoute()

    const preloader = ref(false)

    watch(route, (newValue: any) => {
      if (route.query) end.value = false
      if (props.reqParams.page === (Math.round(props.total / props.reqParams.per_page))) end.value = true
    })

    const showMore = async () => {
      preloader.value = true
      const params = ref(props.reqParams)
      params.value.page += 1
      const showMoreItem = (await axios.get(`${host}${props.apiEndpoint}`, { params: params.value })).data
      props.onShowMoreItem(showMoreItem)
      if (Number(showMoreItem.total) === 0 ||
        params.value.page === (Math.round(showMoreItem.total / params.value.per_page))) end.value = true
      preloader.value = false
    }

    return () => {
      return (
        <div class="show-more-container">
          {preloader.value
            ? (
              <Preloader style="position: relative; margin: 30px auto;"/>
            )
            : (
              props.total > 10 ? (
                <div class="show-more" onClick={showMore}>Показать еще</div>
              ) : null
            )
          }
        </div>
      )
    }
  }
})